<template>
  <div class="modal-overlay" v-if="showUnsubscribeModal" @click.self="close">
    <div class="modal-content">
      <button class="close-btn" @click="close">&times;</button>
      <div class="modal-header">
        <h2><span class="sports">SPORTS</span><span class="hub">HUB</span></h2>
      </div>
      <div class="modal-body" v-if="isUssdUnsubscribe">
        <h3 class="main-heading">Unsubscribe from Sports Hub</h3>
        <p class="sub-heading">To unsubscribe, dial the USSD code below on your phone:</p>
        <p class="ussd-code">{{ unsubscribeInstructions.ussd }}</p>
        <p class="sub-heading">or manage your subscription in the {{ unsubscribeInstructions.app }}.</p>
        <button class="cancel-btn" @click="close">Close</button>
      </div>
      <div class="modal-body" v-else>
        <h3 class="main-heading">Unsubscribe from Sports Hub</h3>
        <p class="sub-heading">Are you sure you want to unsubscribe? You'll lose access to premium features.</p>
        <button class="submit-btn danger" @click="handleUnsubscribe" :disabled="isLoading">
          {{ isLoading ? 'Processing...' : 'Unsubscribe' }}
        </button>
        <button class="cancel-btn" @click="close">Cancel</button>
        <p class="error text-center" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DcbService from '../services/dcbService'
import modalMixin from '@/mixins/modalMixin'
import { getSubscriptionFromGetUser, ServiceIds } from '@/config'
import { VodacomUnSubPopUp, getUnsubscribeInstructions } from '@/functions/VodacomUnSubPopUp'

export default {
  name: 'UnsubscribeModal',
  mixins: [modalMixin],
  computed: {
    ...mapState(['showUnsubscribeModal', 'isLoading', 'error', 'msisdn', 'sessionId', 'serviceId', 'user', 'brandConfig']),

    isUssdUnsubscribe() {
      void this.brandConfig
      return VodacomUnSubPopUp()
    },

    unsubscribeInstructions() {
      void this.brandConfig
      return getUnsubscribeInstructions()
    }
  },
  methods: {
    ...mapMutations(['closeAllModals', 'setIsLoading', 'setError', 'setIsSubscribed', 'setShowUnsubscribeModal', 'setUser', 'setServiceId']),

    applyUnsubscribedState() {
      const updatedUser = {
        ...(this.user || {}),
        status: 'Cancelled',
        isSubscribed: false,
        Subcriptions: [],
        subscriptionCategories: []
      }
      this.setUser(updatedUser)
      this.setIsSubscribed(false)
      this.setShowUnsubscribeModal(false)
      this.close()
    },

    async resolveUnsubscribeServiceId() {
      if (this.serviceId) return this.serviceId

      const userResponse = await DcbService.getUserViaProductId(this.msisdn)
      if (userResponse.success) {
        const { serviceId: normalised } = getSubscriptionFromGetUser(userResponse)
        this.setServiceId(normalised)
        return normalised
      }
      return ServiceIds.premium
    },

    async handleUnsubscribe() {
      this.setIsLoading(true)
      this.setError(null)

      const serviceId = await this.resolveUnsubscribeServiceId()
      const result = await DcbService.unsubscribeUser(this.msisdn, serviceId, this.sessionId)
      this.setIsLoading(false)

      if (result.success) {
        this.applyUnsubscribedState()
      } else {
        this.setError(result.error || 'Unsubscribe failed')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modal-common';

.modal-header {
  margin-bottom: $space-base;

  h3 {
    display: none;
  }
}

.main-heading {
  font-size: 20px;
  font-weight: 800;
  color: $brand-dark;
  margin: 0 0 6px 0;
  text-align: center;
}

.sub-heading {
  font-size: 14px;
  color: $brand-dark;
  margin: 0 0 $space-base 0;
  text-align: center;
  font-weight: 400;
}

.ussd-code {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
  color: $brand-dark;
  text-align: center;
  background: $gray-100;
  border: 1px solid $gray-300;
  border-radius: $radius-sm;
  padding: $space-md;
  margin: 0 0 $space-base 0;
  user-select: all;
}

.submit-btn {
  background: $error;
  margin-bottom: $space-md;

  &:hover:not(:disabled) {
    background: darken($error, 8%);
  }
}

.cancel-btn {
  width: 100%;
  padding: $space-md;
  background: transparent;
  color: $gray-600;
  border: 1px solid $gray-300;
  border-radius: $radius-sm;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all $transition-base;

  &:hover {
    background: $gray-100;
    border-color: $gray-400;
  }

  &:active {
    transform: scale(0.98);
  }
}
</style>
